import { BinsoObject, ParlorDetailProps, ServiceObject } from "@/types/parlor";
import { Box } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  customEvent,
  HLine,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  NextLink,
  Spacing,
  VStack,
} from "goi_common";
import { Dispatch, SetStateAction } from "react";
import { ParlorDetailUvGuidebookBanner } from "./ParlorDetailUvGuidebookBanner";

interface PriceInfoPanelProps {
  expectedCharges: {
    [type: string]: number;
  };
  binsos: Array<BinsoObject>;
  services: ServiceObject;
  parlor: ParlorDetailProps;
  selectedSangjo: string;
  setSelectedSangjo: Dispatch<SetStateAction<string>>;
  discountDescription?: string;
  closestParlors: any;
  isExcluded?: boolean;
  isSimple?: boolean;
}

function PriceInfoTabPanel({
  expectedCharges,

  parlor,
}: PriceInfoPanelProps) {
  return (
    <VStack height="100%">
      <ThisParlorContent231101 expectedCharges={expectedCharges} parlor={parlor} />
    </VStack>
  );
}

type ThisParlorContent231101Props = object & ThisParlorCTACard231101Props;

const ThisParlorContent231101 = ({ expectedCharges, parlor }: ThisParlorContent231101Props) => {
  return (
    <>
      <HLine height="1px" color={colors.gray200} margin="10px 0 35px 0" width="100%" />
      {Number(parlor.id) === 1024 && (
        <ParlorDetailUvGuidebookBanner
          backgroundImageSrc="platform/parlor/parlor_banner_1024.jpg"
          href="/guidebook/tip/etc/8?utm_source=platform&utm_medium=parlor_detail"
          topNode="평촌한림대병원 장례식장"
          bottomNode="이용하기 전에 꼭 알아야 할 것"
          event={{
            newGtm: {
              path: "parlor_detail",
              trigger_and_target: "content-uv_gdb_tip_etc_8",
            },
          }}
        />
      )}

      {/* <ParlorDetailUvGuidebookBanner
        backgroundImageSrc="platform/guidebook/prepare-image.png"
        href="/guidebook/tip/before/4?utm_source=platform&utm_medium=parlor_detail"
        topNode=""
        bottomNode="장례식장 vs 상조회사 나에게 맞는 곳은?"
        event={{
          newGtm: {
            path: "parlor_detail",
            trigger_and_target: "content-uv_gdb_tip_before_4",
          },
        }}
      /> */}

      <ThisParlorCTACard231101 expectedCharges={expectedCharges} parlor={parlor} />
      <Spacing gap={24} />
      <NextLink
        href="/funeral-prepare/1?utm_source=platform&utm_medium=parlor_detail"
        onClick={() => {
          customEvent({
            newGtm: {
              path: "parlor_detail",
              trigger_and_target: "content-uv_funeral_prepare_1",
            },
          });
        }}
      >
        <Box className="subtitle_16_sb orange650" textAlign={"center"}>
          처음하는 장례 준비 어떻게 해야 후회 없을까요? &gt;
        </Box>
      </NextLink>
      <VStack padding="40px 0"></VStack>
    </>
  );
};

interface ThisParlorCTACard231101Props {
  expectedCharges: {
    [type: string]: number;
  };
  parlor: ParlorDetailProps;
}

const ThisParlorCTACard231101 = ({ expectedCharges, parlor }: ThisParlorContent231101Props) => {
  return (
    <VStack gap={24} alignItems="center">
      <h3 css={{ paddingTop: "30px" }} className="subtitle_14_sb gray900">
        장례식장 예상 비용
      </h3>
      <Box textAlign="center" padding="0 16px">
        <span className="subtitle_18_b orange650">
          {expectedCharges["무빈소"].toLocaleString()}원 ~{" "}
          {expectedCharges["일반장"].toLocaleString()}원
        </span>
        <br />
        <br />
        <span className="body_14_m gray800">
          위 비용은 장례용품(인력, 관, 수의, 차량)을 제외한,
          <br /> 조문객 수에 따른 <br /> 장례식장 예상 비용입니다. <br />
          전체 장례 비용(장지, 장례 용품 포함), 상세 장례비용을 더 알아보세요
        </span>
        <br />
        <br />
      </Box>

      <NextLink href={`/match/parlor-requests/${parlor.id}/`}>
        <LargeButton
          css={{ padding: "16px 20px" }}
          buttonType={LARGEL_BUTTON_TYPE.GRAY900}
          onClick={() => {
            customEvent({
              newGtm: { path: "parlor_detail", trigger_and_target: "CTA" },
            });
            customEvent({
              newGtm: { path: "parlor_detail", trigger_and_target: "CTA-uv_match_request" },
            });
          }}
        >
          <HStack gap={10}>
            <span className="button_14_sb white">상세 비용 알아보기</span>
            <ColorIcon name="icon-arrow-right-circle-mono" color={colors.white} size={16} />
          </HStack>
        </LargeButton>
      </NextLink>
    </VStack>
  );
};

export default PriceInfoTabPanel;
